import { EDA } from "motw_core/Dreams/EDreamAttribute";
import * as React from "react";
import { ShowDreamFilter } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Filters/ShowDreamFilter";
import { ShowToday } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Filters/ShowToday";
import Dreams from "source/app/presentation/MainPanel/Dreams/Dreams";
import { ShowAdjacent } from "./Filters/ShowAdjacent";
import { ShowThisWeek } from "./Filters/ShowThisWeek";
import { AverageProblemDifficulty } from "./avgProblemDifficulty/AverageProblemDifficulty";
import * as styles from "./DreamFilterButtons.css";
import { IsFilteringForDreamAttribute } from "./Filters/Helpers/IsFilteringForDreamAttribute";

export const DreamFilterButtons = ({ dreams }: { dreams: Dreams }) => {
    const isProblemFilterActive = IsFilteringForDreamAttribute(
        dreams.state,
        EDA.problem
    );

    return (
        <div>
            <div className={`${styles.grid} ${styles.horizonGrid}`}>
                <ShowToday dreams={dreams} />
                <ShowAdjacent dreams={dreams} />
                <ShowThisWeek dreams={dreams} />
            </div>
            <div className={styles.grid}>
                <span
                    className={styles.compositeItem}
                    style={
                        isProblemFilterActive
                            ? {
                              background: `rgb(0 0 0 / 20%)`,
                                  padding: `5px 0`,
                                  borderRadius: `5px`,
                              }
                            : undefined
                    }
                >
                    <ShowDreamFilter
                        dreams={dreams}
                        attribute={EDA.problem}
                        suppressActiveBackground
                    />
                    <AverageProblemDifficulty {...{ dreams }} />
                </span>
                <ShowDreamFilter {...{ dreams, attribute: EDA.decision }} />
                <ShowDreamFilter {...{ dreams, attribute: EDA.direction }} />
                <ShowDreamFilter {...{ dreams, attribute: EDA.fascination }} />
            </div>
        </div>
    );
};
